<a mat-list-item (click)="toggle()">
    <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}">
        <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Pedagógico">
            <mat-icon>local_library</mat-icon>
            <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Pedagógico</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start stretch">
            <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
        </div>
    </div>
</a>
<mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

    <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

        <!-- REUNIÕES -->
        <sub-menu *ngIf="verificaAcesso(getModulos().REUNIOES_PEDAGOGICO)" icone="event" titulo="Reuniões Pedagógico"
            rota="menu-pedagogico/reunioes" toolTip="Reuniões Pedagógico"></sub-menu>

        <!-- OFICINA -->
        <sub-menu *ngIf="verificaAcesso(getModulos().ATIVIDADE_PEDAGOGICO)" icone="pages" titulo="Atividades Pedagógico" rota="menu-pedagogico/oficinas"
             toolTip="Atividades Pedagógico"></sub-menu>
                  
        <!-- TURMA -->
        <sub-menu *ngIf="verificaAcesso(getModulos().TURMAS)" icone="chrome_reader_mode" titulo="Turmas" rota="menu-pedagogico/turmas"
             toolTip="Turmas"></sub-menu>            

        <!-- MATRICULA NA TURMA-->
        <sub-menu *ngIf="verificaAcesso(getModulos().MATRICULA)" icone="school" titulo="Matrícula na Turma"
            rota="matriculas" toolTip="Matrícula na Turma"></sub-menu>

        <!-- PLANEJAMENTO DE OFICINAS -->
        <sub-menu *ngIf="verificaAcesso(getModulos().OFICINA_TURMAS)" icone="pages" titulo="Planejamento de Oficinas" rota="menu-pedagogico/oficinaturmas"
        toolTip="Planejamento de Oficinas"></sub-menu>

        <!-- AVALIACAO ATIVIDADE -->
        <!--sub-menu *ngIf="verificaAcesso(getModulos().AVALIACAO_ATIVIDADE)" icone="done_all"
            titulo="Avaliação da Turma" rota="avaliacaoatividade" toolTip="Avaliação da Turma"></sub-menu-->


        <!-- ACOES_ATIVIDADE -->
        <sub-menu *ngIf="verificaAcesso(getModulos().ACOES_ATIVIDADE)" 
                  icone="event_busy"
                  titulo="Planejamento das Atividades"
                  rota="acoesoficinas" 
                  toolTip="Planejamento das Atividades"></sub-menu>

        <!-- ACAO_EXECUTADA -->
        <sub-menu *ngIf="verificaAcesso(getModulos().ACAO_EXECUTADA)"
                  icone="event_note"
                  titulo="Ações Executadas"
                  rota="acaoExecutada"
                  toolTip="Ações Executadas"></sub-menu>

        <!-- MATRICULA NA OFICINA -->
        <sub-menu *ngIf="verificaAcesso(getModulos().MATRICULA_ATIVIDADE_ALUNO_PEDAGOGICO)" icone="sports_handball" titulo="Matrícula na Atividade"
            rota="menu-pedagogico/atividadealuno" toolTip="Matrícula na Atividade"></sub-menu>

        <!-- FREQUENCIA ALUNO-->
        <sub-menu *ngIf="verificaAcesso(getModulos().FREQUENCIA_ALUNO)" icone="check_circle_outline"
            titulo="Frequência do Beneficiário" rota="frequenciaaluno" toolTip="Frequência do Beneficiário"></sub-menu>

        <!-- AVALIACAO ALUNO -->
        <sub-menu *ngIf="verificaAcesso(getModulos().AVALIACAO_ALUNO)" icone="done" titulo="Avaliação do Beneficiário"
            rota="avaliacaoaluno" toolTip="Avaliação do Beneficiário"></sub-menu>

        <!-- ALUNO TRABALHANDO -->
        <sub-menu *ngIf="verificaAcesso(getModulos().ALUNO_TRABALHANDO)" icone="accessibility"
            titulo="Cadastro de Aprendiz" rota="alunotrabalhando" toolTip="Cadastro de Aprendiz"></sub-menu>

        <!-- TIPO_OCORRENCIA_ALUNO -->
        <!--sub-menu *ngIf="verificaAcesso(getModulos().TIPO_OCORRENCIA_ALUNO)" icone="block" titulo="Tipo de ocorrência do aluno"
            rota="tipoocorrenciaaluno" toolTip="Tipo de ocorrência do aluno"></sub-menu-->

        <!-- OCORRENCIA_ALUNO -->
        <sub-menu *ngIf="verificaAcesso(getModulos().OCORRENCIA_ALUNO)" icone="how_to_reg" titulo="Ocorrência do Beneficiário"
            rota="ocorrenciaaluno" toolTip="Ocorrência do Beneficiário"></sub-menu>

        <!-- NIVEIS TURMAS -->
        <!--sub-menu *ngIf="verificaAcesso(getModulos().NIVEIS_TURMAS)" icone="timeline" titulo="Níveis de turmas" 
            rota="niveisturmas" toolTip="Níveis de Turmas"></sub-menu-->

            
        <!-- REPROVACAO ALUNO  
        <sub-menu *ngIf="verificaAcesso(getModulos().REPROVACAO_ALUNO)" icone="event_busy"
            titulo="Reprovações do Aluno " rota="reprovacaoaluno" toolTip="Reprovações do Aluno"></sub-menu>
        -->

        <!-- PERCURSO -->
        <sub-menu *ngIf="verificaAcesso(getModulos().PERCURSO)"
                  icone="timeline"
                  titulo="Percursos"
                  rota="percurso"
                  toolTip="Percursos"></sub-menu>

        <!-- TABELAS REFERENCIA -->
        <tb-referencia-pedagogico></tb-referencia-pedagogico>


    </div>
</mat-nav-list>